<template>
  <div class="bg" v-show="show">
    <div class="wrapper">
      <div class="title">选择语音合成类型</div>
      <div class="radio-container">
        <el-radio v-model="radio" :label="1" class="radio-item">主持人音色语音合成</el-radio>
        <el-radio v-model="radio" :label="2" class="radio-item">系统默认音色语音合成</el-radio>
      </div>
      <div class="btn-container">
        <el-button class="btn btn-primary" @click="confirm">确定</el-button>
        <el-button class="btn" @click="close">取消</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import common from '@common/common'
import { apis } from "@common/config";
import { Radio } from "element-ui";
export default {
  name: 'VoiceComposeSelectDialog',
  components: {
    "el-radio": Radio
  },
  data() {
    return {
      show: false,
      config: {},
      r: null,
      radio: 1
    }
  },
  methods: {
    open(c, r) {
      this.config = c
      this.r = r
      this.getSpeechFunc()
    },
    close() {
      this.show = false
    },
    confirm() {
      if (this.radio) {
        let route = ''
        if (this.radio == 2) {
          route = `/voiceCompose`
        } else if (this.radio == 1) {
          route = `/voiceComposeCustom`
        }

        if (route) {
          if(this.config){
            if (this.config.id) {
              route = `${route}?id=${this.config.id}`
            }
            if (this.config.objId) {
              route = `${route}?oid=${this.config.objId}`
            }
            if (this.config.objtype) {
              route += `&ot=${this.config.objtype}`
            }
            if (this.config.type) {
              route += `&t=${this.config.type}`
            }
          }

          if (this.r && this.radio == 2) {
            this.r('/voiceCompose')
          } else {
            common.jump(route, true)
          }
        }
        this.show = false
      } else {
        this.$message.error('请选择语音合成类型')
      }
    },
    getSpeechFunc() {
      common.myFetch(apis.getSpeechTtsFuncList, {}).then((data) => {
        if (data) {
          if (data.speech_tts == 1 && data.system == 1) {
            // 两个都有，显示弹窗
            this.show = true
          } else if (data.speech_tts == 1 && data.system == 0) {
            // 只有语音合成
            this.radio = 1
            this.confirm()
          } else if (data.speech_tts == 0 && data.system == 1) {
            // 只有系统合成
            this.radio = 2
            this.confirm()
          } else {
            // 都没有，直接跳转到语音合成页面
            // common.jump(`/voiceCompose`, true)
            this.radio = 2
            this.confirm()
          }
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
@import '../../assets/css/global.less';
.bg {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: rgba(50,59,75,0.3);
  backdrop-filter: blur(1.6px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1008;
}
.wrapper {
  width: 432px;
  height: 210px;
  background: #FFFFFF;
  box-shadow: 0px 4px 12px 0px rgba(0,0,0,0.15);
  border-radius: 4px;
  padding: 32px 32px 24px 32px;
}
.title {
  font-family: PingFang-SC, PingFang-SC;
  font-weight: bold;
  font-size: 16px;
  color: rgba(50,59,75,0.85);
  line-height: 24px;
  text-align: left;
  font-style: normal;
  margin-bottom: 20px;
}
.radio-container {
  display: flex;
  flex-direction: column;

  .radio-item {
    margin-bottom: 18px;

    /deep/.el-radio__input.is-checked .el-radio__inner {
      border-color: @green;
      background:  @green;
    }

    /deep/.el-radio__input.is-checked+.el-radio__label {
      color: #666666;
      font-family: PingFang-SC, PingFang-SC;
      font-weight: 500;
      font-size: 14px;
    }
  }
}
.btn-container {
  display: flex;
  justify-content: flex-end;
  margin-top: 2px;

  .btn {
    width: 65px;
    height: 32px;
    background: @dateColor;
    border-radius: 4px;
    font-family: PingFang-SC, PingFang-SC;
    // font-weight: bold;
    font-size: 14px;
    color: #FFFFFF;
    padding: 0;
    border: none;
    outline: none;
  }

  .btn-primary {
    background: @green;
  }
}
</style>